import { render } from "./inbox.vue?vue&type=template&id=efb3b73a"
import script from "./inbox.vue?vue&type=script&lang=js"
export * from "./inbox.vue?vue&type=script&lang=js"

import "./inbox.vue?vue&type=style&index=0&id=efb3b73a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__